import { z } from 'zod';
import { dia, uuid } from './comunes';

export const crearPromocionSchema = z
  .object({
    nombre: z.string().trim().min(2).max(80),
    descripcion: z.string().trim().max(300).optional(),
    tipo: z.enum(['porcentaje', 'monto', 'paquete']),
    /** porcentaje: % ×100 · monto: centavos por unidad · paquete: precio total del paquete en centavos. */
    valor: z.number().int().positive(),
    /** En paquete: los servicios que lo forman (mínimo 2). */
    servicioIds: z.array(uuid).max(50).default([]),
    productoIds: z.array(uuid).max(50).default([]),
    vigenteDesde: dia,
    vigenteHasta: dia.optional(),
  })
  .superRefine((p, ctx) => {
    if (p.tipo === 'porcentaje' && p.valor > 10000) ctx.addIssue({ code: 'custom', message: 'El porcentaje no puede pasar de 100', path: ['valor'] });
    if (p.tipo === 'paquete' && p.servicioIds.length < 2) ctx.addIssue({ code: 'custom', message: 'Un paquete necesita al menos dos servicios', path: ['servicioIds'] });
    if (p.vigenteHasta && p.vigenteHasta < p.vigenteDesde) ctx.addIssue({ code: 'custom', message: 'La fecha final debe ser posterior a la inicial', path: ['vigenteHasta'] });
  });
export type CrearPromocionInput = z.infer<typeof crearPromocionSchema>;

/** Sin `lineaIds` (o vacío) = todo el carrito; con `lineaIds` = solo esas líneas. */
export const aplicarPromocionVentaSchema = z.object({ promocionId: uuid, lineaIds: z.array(uuid).max(100).optional() });
export type AplicarPromocionVentaInput = z.infer<typeof aplicarPromocionVentaSchema>;

export interface PromocionVista {
  id: string;
  nombre: string;
  descripcion: string | null;
  tipo: 'porcentaje' | 'monto' | 'paquete';
  valor: number;
  servicioIds: string[];
  productoIds: string[];
  vigenteDesde: string;
  vigenteHasta: string | null;
  estado: 'propuesta' | 'autorizada' | 'rechazada' | 'expirada';
  sistema: boolean;
  vigente: boolean;
}
